// extracted by mini-css-extract-plugin
export var boxItems = "_6p-1";
export var button = "_6p-4";
export var filterGroupBox = "_6p-0";
export var iconSecondary = "_6p-3";
export var iconWrapper = "_6p-2";